import { render, staticRenderFns } from "./definition-la-communication-digitale-cest-quoi.vue?vue&type=template&id=472ccc4f&"
import script from "./definition-la-communication-digitale-cest-quoi.vue?vue&type=script&lang=js&"
export * from "./definition-la-communication-digitale-cest-quoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports